import CountDown from "@/components/ActivityBanner/countDown";
import HBAvatar from "@/components/Avatar";
import formatTime from "@/utils/formatTime";
import { useContext } from "react";
import { getVipTypeByUser, vipTag } from "../../../constants/vip";
import Image from "../../Image";
import { VipDialogContext } from "./configContext";
import styles from "./index.module.less";

export default function VipHeader({ user, config } = {}) {
  const { rightData, certSubjects } = useContext(VipDialogContext);

  const vipInfo = rightData?.vips[0];
  const vipType = getVipTypeByUser(user);

  const isAuthPro = rightData?.auth_rights?.length;

  return (
    <div className={styles.header3} style={{ background: config?.bg }}>
      <div className={styles.user}>
        <HBAvatar
          className={styles.avatar}
          user={user}
          size={50}
          shape={"circle"}
        />
        <div>
          <div className={styles.account}>充值账号：{user.username}</div>
          <div className={styles.info}>
            {vipInfo ? (
              <Image src={vipTag[vipType]} alt="会员标识" />
            ) : (
              <Image src={vipTag.no} alt="未开通" />
            )}

            {vipInfo && (
              <span>
                {formatTime(rightData.vip_expire, "YYYY/MM/DD")}
                到期 | 每天可下载
                {rightData.downloadCount[0] &&
                  rightData.downloadCount[0].quantity}
                个 (当前可用
                <span className={styles.number}>
                  {rightData.downloadCount[0] &&
                    rightData.downloadCount[0].left}
                </span>
                ){isAuthPro ? " | 高级授权" : ""}
                {certSubjects?.length > 0 &&
                  ` | 授权主体${certSubjects?.length}个`}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className={styles.brand}>
        <div className={styles.bg}>
          <Image
            alt="bg"
            src={
              config?.bgImage?.[0]?.url ||
              "https://grocery-cdn.huaban.com/file/6cfe4020-7605-11ee-a754-5d757dcca2d8.png"
            }
            width={435}
          />
        </div>

        {config?.countDown?.targetDate && (
          <CountDown className={styles.countdown} {...config?.countDown} />
        )}
      </div>
    </div>
  );
}
